module.exports = __webpack_public_path__ + "img/20210801_133147.1cb2040e.jpg";